import { rem, styled, theme } from 'design-system';

export const Section = styled('section', {
  paddingLeft: rem(32),
  paddingRight: rem(32),
  minWidth: rem(1104),
});

export const SectionInner = styled('div', {
  marginLeft: 'auto',
  marginRight: 'auto',
  width: rem(1040),
});

export const Container = styled('div', {
  marginLeft: 'auto',
  marginRight: 'auto',
  width: rem(1170),
});

export const TopContainer = styled('div', {
  variants: {
    journal: {
      bmj: {
        fontFamily: 'RobotoRegular',
      },
    },
  },
  compoundVariants: [
    {
      journal: 'bmj',
      css: {
        '& button': {
          fontFamily: 'RobotoRegular',
        },
      },
    },
  ],
  '& button': {
    fontFamily: 'IBM Plex Sans',
  },
});

export const SectionNew = styled('div', {
  paddingTop: rem(80),
  paddingBottom: rem(80),
  background: theme.colors.white,
  paddingLeft: rem(32),
  paddingRight: rem(32),
  minWidth: rem(1234),
  variants: {
    size: {
      sm: {
        paddingTop: rem(40),
        paddingBottom: rem(40),
      },
      md: {
        paddingTop: rem(60),
        paddingBottom: rem(60),
      },
      lg: {
        paddingTop: rem(70),
        paddingBottom: rem(70),
      },
    },
    bgTheme: {
      gray: {
        background: theme.colors.gray2,
      },
      grayDark: {
        background: theme.colors.gray5,
      },
      yellow: {
        background:
          'linear-gradient(to top, rgba(249, 240, 209, 1), rgba(249, 240, 209, 0.5), rgba(249, 240, 209, 0))',
      },
      darkBlue: {
        background: 'rgba(5, 30, 87, 1)',
      },
      lightBlue1: {
        background: 'rgba(237, 243, 255, 1)',
      },
      lightBlue2: {
        background: 'rgba(225, 235, 255, 1)',
      },
      white: {
        background: 'rgba(255, 255, 255, 1)',
      },
    },
  },
});

export const SectionEditorial = styled('div', {
  paddingTop: rem(60),
  paddingBottom: rem(60),
  background: theme.colors.white,
  paddingLeft: rem(32),
  paddingRight: rem(32),
  minWidth: rem(1234),
  variants: {
    size: {
      sm: {
        paddingTop: rem(40),
        paddingBottom: rem(40),
      },
      md: {
        paddingTop: rem(60),
        paddingBottom: rem(60),
      },
      lg: {
        paddingTop: rem(70),
        paddingBottom: rem(70),
      },
    },
    bgTheme: {
      gray: {
        background: theme.colors.gray2,
      },
      grayDark: {
        background: theme.colors.gray5,
      },
      yellow: {
        background:
          'linear-gradient(to top, rgba(249, 240, 209, 1), rgba(249, 240, 209, 0.5), rgba(249, 240, 209, 0))',
      },
      darkBlue: {
        background: 'rgba(5, 30, 87, 1)',
      },
      lightBlue1: {
        background: 'rgba(237, 243, 255, 1)',
      },
      lightBlue2: {
        background: 'rgba(225, 235, 255, 1)',
      },
      white: {
        background: 'rgba(255, 255, 255, 1)',
      },
    },
  },
});

export const CustomFontHeaderContainer = styled('div', {
  fontFamily: 'IBM Plex Serif',
  variants: {
    journal: {
      bmj: {
        fontFamily: 'RobotoBold',
      },
    },
  },
});
export const CustomFontHeaderContainerPayment = styled('div', {
  fontFamily: theme.fonts.sansSerif.value,
  color: theme.colors.blue12.value,
  variants: {
    journal: {
      bmj: {
        fontFamily: 'RobotoBold',
      },
    },
  },
});
